var _g, _g2, _g3, _g4, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientStep1Bg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 802,
    height: 732,
    viewBox: "0 0 802 732",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.408 324.841C196.887 340.14 410.012 356.329 621.359 325.375",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 389.623C196.887 374.324 410.012 358.464 621.359 389.418",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 422.508C188.526 391.019 417.484 357.93 621.359 422.508",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 453.463C217.346 399.559 452.709 373.941 621.359 452.929",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 261.99C217.346 315.894 452.709 341.512 621.359 262.524",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 483.883C201.868 421.974 442.568 370.204 621.359 485.484",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 514.838C187.992 445.991 435.096 369.137 621.359 516.439",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 542.591C185.323 468.407 427.091 371.273 621.359 544.192",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 574.614C230.688 453.463 450.04 397.958 621.359 576.215",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 141.486C230.688 262.637 450.04 318.142 621.359 139.885",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 172.635C185.323 246.82 427.091 343.954 621.359 171.034",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 200.101C187.992 268.949 435.096 345.802 621.359 198.5",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 230.695C201.868 292.604 442.568 344.374 621.359 229.094",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 292.606C188.526 324.095 417.484 357.185 621.359 292.606",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.874 212.763V501.496",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.183 190.881L175.183 522.844",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.161 165.264L143.161 550.597",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 141.78L115.408 575.147",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.408 358.231H620.339",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.699 230.375L246.699 485.485",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.194 241.049L286.194 472.676",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.755 250.655L326.755 464.137",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.316 253.857L367.316 464.137",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.945 251.724L408.945 467.34",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.506 244.251L449.506 472.676",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 231.442L489 484.418",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.36 213.297L526.36 501.497",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.517 190.881L560.517 522.844",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.539 164.196L592.539 549.53",
    stroke: "#511684",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.359 134.309L621.359 582.619",
    stroke: "#511684",
    strokeWidth: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3706_9505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 122.115,
    cy: 509.852,
    r: 124.734,
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3706_9505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 130.162,
    cy: 190.64,
    r: 124.734,
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3706_9505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 608.981,
    cy: 200.029,
    r: 88.5211,
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3706_9505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 368.924,
    cy: 359.413,
    r: 91.2035,
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3706_9505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 592.886,
    cy: 523.266,
    r: 124.734,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3706_9505",
    x: -86.6196,
    y: 301.118,
    width: 417.468,
    height: 417.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42,
    result: "effect1_foregroundBlur_3706_9505"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3706_9505",
    x: -78.5723,
    y: -18.0938,
    width: 417.468,
    height: 417.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42,
    result: "effect1_foregroundBlur_3706_9505"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3706_9505",
    x: 436.459,
    y: 27.5078,
    width: 345.042,
    height: 345.042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42,
    result: "effect1_foregroundBlur_3706_9505"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3706_9505",
    x: 258.721,
    y: 264.209,
    width: 228.407,
    height: 228.407,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5,
    result: "effect1_foregroundBlur_3706_9505"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3706_9505",
    x: 384.152,
    y: 314.531,
    width: 417.468,
    height: 417.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42,
    result: "effect1_foregroundBlur_3706_9505"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientStep1Bg);
export default __webpack_public_path__ + "static/media/clientStep1bg.0f03c0833980681c0c4826ad72f6d4e3.svg";
export { ForwardRef as ReactComponent };